import { TableStoryblok } from "@storyblok-types"
import { Paragraph } from "@ui-library/typography/Body"
import { Label } from "@ui-library/typography/Labels"

const Table = ({ data }: { data: TableStoryblok }) => {
  return (
    <div className="overflow-x-auto">
      <table className={`mx-auto my-8 w-max min-w-[20rem] text-left`}>
        <thead>
          <tr>
            {data.thead.map(th => (
              <th className="pb-3 pr-8" key={th._uid}>
                <Label size="small">{th.value}</Label>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.tbody.map(row => (
            <tr key={row._uid}>
              {row.body.map(cell => (
                <td key={cell._uid} className="pr-7">
                  <Paragraph size="small">{cell.value}</Paragraph>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Table
